<span class="c-m-right-md" *ngIf="isVersionsChangeAllowed$ | async">
  <spr-dropdown
    color="secondary"
    [selectedOptionId]="selectedDealVersion$ | async"
    [items]="versionSelectionItems$ | async"
    (selected)="setDealVersion($event)"
  >
    <ng-template #buttonTemplate>
      <i class="fa fa-gear c-align-self-center version-selector-icon"></i>
    </ng-template>

    <ng-template #itemTemplate let-item="item">
      <span class="c-text-bold">{{ item.text }}</span>
      <p class="c-m-0 c-m-right-md c-text-sm c-text-normal">
        {{ item.description }}
      </p>
    </ng-template>
  </spr-dropdown>
</span>
